import { createContext, useContext, useEffect, useState } from 'react';
import { toast } from 'sonner';

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export const itemKey = (i) => `${i.product.id}|${i.size || ''}`;

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem('cart') || '[]'); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem('cart', JSON.stringify(items)); }, [items]);

  const add = (product, quantity = 1, size = null) => {
    setItems((prev) => {
      const found = prev.find((i) => i.product.id === product.id && (i.size || null) === (size || null));
      if (found) return prev.map((i) => (i === found ? { ...i, quantity: i.quantity + quantity } : i));
      return [...prev, { product, quantity, size: size || null }];
    });
    toast.success(`${product.name}${size ? ` (Size ${size})` : ''} added to bag`);
    setOpen(true);
  };

  const updateQty = (key, quantity) => {
    if (quantity < 1) return remove(key);
    setItems((prev) => prev.map((i) => (itemKey(i) === key ? { ...i, quantity } : i)));
  };

  const remove = (key) => setItems((prev) => prev.filter((i) => itemKey(i) !== key));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.product.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, open, setOpen, add, updateQty, remove, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
}
